export default __webpack_public_path__ + "static/media/km.54dd5fcf.svg";